import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { api, errorText } from '../lib/api';
import { Button, ErrorText, Input } from '../components/ui';

export function LoginPage() {
  const [params] = useSearchParams();
  const cfg = useQuery({ queryKey: ['auth-config'], queryFn: () => api.get<{ google: boolean; devLogin: boolean; device: boolean }>('/auth/config') });
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(params.get('error'));
  const navigate = useNavigate();
  const qc = useQueryClient();

  const devLogin = async () => {
    setError(null);
    try {
      await api.post('/auth/dev-login', { email });
      await qc.invalidateQueries();
      navigate('/');
    } catch (e) {
      setError(errorText(e));
    }
  };

  // An enrolled (or waiting) iPad signs in with a PIN, not Google; ?office=1 is the Manager's way in.
  if (cfg.data?.device && !params.has('office')) return <Navigate to="/m" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
      <div className="w-full max-w-sm space-y-5 rounded-lg bg-white p-8 shadow">
        <h1 className="text-xl font-bold">Sign in</h1>
        <ErrorText error={error} />
        {cfg.data?.google ? (
          <a href="/auth/google" className="flex w-full items-center justify-center rounded-md bg-blue-700 px-4 py-3 font-semibold text-white hover:bg-blue-800">
            Sign in with Google
          </a>
        ) : (
          cfg.data && <p className="text-sm text-slate-600">Google sign-in isn't set up yet.</p>
        )}
        <div className="border-t pt-4">
          <a href="/m" className="flex w-full items-center justify-center rounded-md bg-slate-800 px-4 py-3 font-semibold text-white hover:bg-slate-900">
            Mechanic? Sign in with your PIN
          </a>
          <p className="mt-2 text-xs text-slate-500">On a new iPad you'll be asked to send a setup request; the Manager approves it.</p>
        </div>
        {cfg.data?.devLogin && (
          <div className="space-y-2 border-t pt-4">
            <p className="text-xs font-semibold uppercase text-amber-700">Development sign-in</p>
            <Input placeholder="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && devLogin()} />
            <Button variant="secondary" className="w-full" onClick={devLogin}>Sign in (dev)</Button>
          </div>
        )}
      </div>
    </div>
  );
}
